module.exports = __webpack_public_path__ + "img/LUB00405.b2db1386.png";